import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../utils/analytics';

// Page title mapping
const pageTitles = {
    '/': 'Home',
    '/login': 'Login',
    '/register': 'Register',
    '/dashboard': 'Dashboard',
    '/symptom-check': 'Symptom Check',
    '/history': 'Health History',
    '/health-library': 'Health Library',
    '/nearby': 'Find Care',
    '/settings': 'Settings',
    '/subscription': 'Subscription',
    '/consultations': 'Consultations',
    '/forgot-password': 'Forgot Password',
    '/reset-password': 'Reset Password',
};

export function AnalyticsProvider({ children }) {
    const location = useLocation();

    // Initialize analytics on mount
    useEffect(() => {
        initAnalytics();
    }, []);

    // Track page views on route change
    useEffect(() => {
        const path = location.pathname;
        const title = pageTitles[path] || 'MediGuide';
        
        // Small delay to ensure page has rendered
        const timer = setTimeout(() => {
            trackPageView(path, `MediGuide - ${title}`);
        }, 100);

        return () => clearTimeout(timer);
    }, [location]);

    return <>{children}</>;
}

export default AnalyticsProvider;
